module.exports = __webpack_public_path__ + "media/images/map/7-29de280c7922fbf6e7f85661b2dcbc31.png";